import React, { useState } from 'react';
import { NewTabLink } from '../../commons/components/NewTabLink';
import { billingPortalConfig } from '../../commons/config';
import { AnalyticsEvent } from '../../web-analytics/AnalyticsEvent';
import { Button } from 'react-bootstrap';

export const SocialMediaIntegrationBanner = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isStepsExpanded, setIsStepsExpanded] = useState(false);
  const supportUrl =
    process.env.REACT_APP_SUPPORT_CONSULTATION_URL ??
    billingPortalConfig.loyaltyBenefitsConsultationUrl ??
    'https://growegy.com/';

  return isExpanded ? (
    <div className="offer-container">
      Connect your Facebook and Instagram accounts to streamline your social media management. Write
      a post once and publish it to multiple social media accounts simultaneously. Schedule posts
      for the future to keep your social media activities organized and professional.
      <strong>Choose your integration option:</strong>
      <div>
        <strong>"Facebook & Instagram"</strong> - This option connects both Facebook and Instagram
        through your Meta Business account. Your Instagram account must be linked to a Facebook Page
        through Facebook Business. This setup takes a bit more time, but it gives you access to the
        full power of Facebook Business tools to manage all your Meta accounts in one place. Perfect
        if you want to manage both platforms together.
      </div>
      <div>
        <strong>"Instagram Business"</strong> - This is a simpler option if you only need Instagram.
        Connect your Instagram Business account directly without needing to link it to Facebook.
        This is the quickest way to get started if Instagram is your main focus.
      </div>
      <div>
        <strong>What you'll need:</strong> For "Facebook & Instagram", you'll need a Meta Business
        account, a Facebook Page (not a personal profile), and an Instagram Business account linked
        to that Facebook Page. For "Instagram Business" only, you'll just need an Instagram Business
        account. Once your accounts are set up, click the "Connect" button below to authorize
        Growegy to access your accounts.
      </div>
      <div>
        <span
          onClick={() => setIsStepsExpanded(!isStepsExpanded)}
          style={{
            cursor: 'pointer',
            textDecoration: 'underline',
            textDecorationStyle: 'dashed',
            fontWeight: 'bold',
          }}
        >
          How to convert your personal Instagram account to a Business account
        </span>
        {isStepsExpanded && (
          <div>
            <ol>
              <li>Open the Instagram app on your mobile device and go to your profile.</li>
              <li>Tap the menu icon (three horizontal lines) in the top right corner.</li>
              <li>Scroll down and select "Account type and tools".</li>
              <li>Select "Switch to Professional Account".</li>
              <li>
                Follow the steps and choose "Business" (not "Creator") as your account type when
                asked.
              </li>
              <li>
                Connect your Instagram Business account to a Facebook Page. If you don't have a
                Facebook Page, you'll be prompted to create one.
              </li>
            </ol>
          </div>
        )}
      </div>
      <div>
        Having trouble setting things up?{' '}
        <NewTabLink
          href={supportUrl}
          analyticsEvent={AnalyticsEvent.CONSULTATION_SCHEDULER_OPENED}
          analyticsProperties={{ source: 'social-media-integrations-banner' }}
        >
          Schedule a 1-on-1 consultation with your account manager
        </NewTabLink>
        .
        <div style={{ marginTop: '16px' }}>
          <Button
            variant="light"
            className="upgrade-to-annual__hide-button"
            onClick={() => setIsExpanded(false)}
          >
            Collapse
          </Button>
        </div>
      </div>
    </div>
  ) : (
    <div className="billing__banner">
      <div>
        Connect your Facebook and Instagram accounts to streamline your social media management.
        Write a post once and publish it to multiple social media accounts simultaneously.
      </div>
      <Button
        variant="primary"
        className="upgrade-to-annual__apply-button"
        onClick={() => setIsExpanded(true)}
      >
        Learn more
      </Button>
    </div>
  );
};
